<template>
  <div id="usuarios">
    <v-container grid-list-xl fluid>
      <v-layout row wrap>
        <v-flex xs12 >
          <h4 class="grey--text text--darken-1">
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <v-icon small color="primary">drag_indicator</v-icon>
              </template>
              <span>Menú Principal</span>
            </v-tooltip>Perfil de Usuario
          </h4>
        </v-flex>
        <!-- <v-spacer></v-spacer> -->
      </v-layout>
      <v-card>
        <!-- <v-card-title>
        </v-card-title> -->
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs12 sm8>
              <v-text-field
                type="text"
                label="Nombres"
                v-model="usuario.persona.nombre"
                disabled
              ></v-text-field>
              <v-text-field
                type="text"
                label="Apellido Paterno"
                v-model="usuario.persona.paterno"
                required
                disabled
              ></v-text-field>
              <v-text-field
                type="text"
                label="Apellido Materno"
                v-model="usuario.persona.materno"
                disabled
              ></v-text-field>
              <v-text-field
                type="text"
                label="Teléfono"
                v-model="usuario.persona.celular"
                required
                :disabled="!mode"
              ></v-text-field>
              <v-text-field
                type="text"
                label="Correo electrónico"
                v-model="usuario.persona.correo"
                required
                :disabled="!mode"
              ></v-text-field>
            </v-flex>
            <v-flex xs12 sm4>
              <v-switch
                :label="'Cambiar datos de acceso: '+(mode?'Si':'No')"
                v-model="mode"
              ></v-switch>
              <v-text-field
                type="text"
                label="Usuario"
                v-model="usuario.username"
                :rules="[v => !!v || 'El campo es requerido']"
                disabled
              ></v-text-field>
              <v-text-field
                type="password"
                label="Contraseña"
                v-model="usuario.password"
                :rules="[v => !!v || 'El campo es requerido']"
                :disabled="!mode"
                required
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            :disabled="!mode"
            color="primary darken-1"
            @click.native="updateUsuario"
          >
            Guardar
          </v-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-container>
    <v-dialog v-model="cdialog" persistent max-width="300px">
      <v-card>
        <v-card-title class="headline grey lighten-3">
          <span class="headline">Alerta</span>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="text-xs-center">
          <span class="grey--text text--darken-2 subheading">
            ¿Está seguro de cambiar el Usuario y/o Contraseña?
          </span>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success darken-1" flat @click.native="sendUsuario">
            Aceptar
          </v-btn>
          <v-btn color="blue darken-1" flat @click.native="cdialog == false">
            Cerrar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-snackbar
      v-model="snack.state"
      :top="'top'"
      :right="'right'"
      :color="snack.color"
      :multi-line="snack.mode === 'multi-line'"
      :timeout="2500"
      :vertical="snack.mode === 'vertical'"
    >
      {{ snack.text }}
    </v-snackbar>
  </div>
</template>
<script>
/* eslint-disable no-console */
import Service from '../services/general';
import axios from 'axios';
export default {
  name: 'usuario',
  data() {
    return {
      usuario: {
        persona: {
        id: '',
        nombre: '',
        paterno: '',
        materno: '',
        celular: '',
        rol_id: '',
        username: '',
        password: '',
        estado: ''
        }
      },
      mdialog: false,
      mconfirm: false,
      mode: false,
      snack: {
        state: false,
        color: 'success',
        mode: '',
        timeout: 2500,
        text: ''
      }
    };
  },
  mounted() {
    this.estados = [
      { id: true, descripcion: 'activo' },
      { id: false, descripcion: 'inactivo' }
    ];
    this.getUsuario();
  },
  methods: {
    getUsuario() { 
      axios
        .get(Service.getBase() + 'usuario', Service.getHeader())
        .then(response => {
          this.usuario = response.data; 
        })
        .catch(error => {
          console.error('Error al cargar registros', error);
        }); 
    },

    confirmUsuario(data) { 
      this.mode = false;
      this.usuario = data;
      this.mdialog = true;
    },

    updateUsuario() { 
      //if (this.$refs.form.validate()) {
        axios
          .put(Service.getBase() + 'usuario/' + this.usuario.id, this.usuario, Service.getHeader())
          .then(() => {
            this.toast('success', 'Registro actualizado');
            this.mdialog = false;
          })
          .catch(() => {
            this.toast('error', 'No se pudo actualizar');
            console.error('Error al actualizar');
          });
      //}
    },
    toast(color, text) {
      this.snack.color = color;
      this.snack.text = text;
      this.snack.state = true;
    }
  }
};
</script>